import { render, staticRenderFns } from "./noaccess.vue?vue&type=template&id=2a594955&"
import script from "./noaccess.vue?vue&type=script&lang=js&"
export * from "./noaccess.vue?vue&type=script&lang=js&"
import style0 from "./noaccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports